function Paragraph({ title, pRef, children }) {
  return (
    <div className="flex flex-col gap-6 w-full" id={pRef}>
      <div className="highlightText">{title}</div>
      {children}
    </div>
  );
}

export default Paragraph;
